import { RouteComponentProps } from '@reach/router';
import _ from "lodash"
import BiDataExport from "components/import-export/bi-data-export";
import Import from "components/import-export/import";
import { ImportExport_s } from 'components/import-export/import-export-styles';
import RdcfExport from "components/import-export/rdcf-export";
import ThirdPartyImport from 'components/import-export/third-party-import';
import VTSImport from "components/import-export/vts-import";
import AEExport from "components/import-export/ae-export"
import { local } from 'data/lib/local-json';
import toggles from "feature-toggles"
import { aeExportOrgs } from "data/config/org-flags"
// Components
import { TabPanel, TabView } from 'primereact/tabview';
import React from "react";
// Styles
import { Tabs_s } from 'styles/tab-styles';

const FolderImportExport = (props: RouteComponentProps) => {
  const profile        = local('auth.profile');
  const isProfessional = profile && profile.licensetype && profile.licensetype.name === 'professional';
  const organizationId = _.get(profile, 'organizationId')

  const tabs = [
    <TabPanel header="rDCF Export" key="rdcfExport"><RdcfExport /></TabPanel>,
    <TabPanel header="rDCF Update" key="rdcfUpdate"><Import /></TabPanel>,
    isProfessional && <TabPanel header="AE Import" key="aeImport"><ThirdPartyImport /></TabPanel>,
    (toggles.displayAEExport() && (process.env.SWARM_ENV == 'production' ? aeExportOrgs.includes(organizationId) : true)) && <TabPanel header="AE Export" key="aeExport"><AEExport /></TabPanel>,
    <TabPanel header="VTS Import" key="vtsImport"><VTSImport /></TabPanel>,
    <TabPanel header="BI Data Export" key="biExport"><BiDataExport /></TabPanel>
  ].filter(Boolean)

  return (
    <ImportExport_s>
      <Tabs_s>
        <TabView>
          { tabs }
        </TabView>
      </Tabs_s>
    </ImportExport_s>
  )
}

export default FolderImportExport
